import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SearchParametersConst } from '../search-parameters.const';
import { formatUrlName } from '../util.functions';
import { LanguageService } from './language.service';
import { AppRoutePath, getTranslatedRoutePath } from '../route-translation';

@Injectable({ providedIn: 'root' })
export class ReservationPageNavigationService {
	private readonly router = inject(Router);
	private readonly languageService = inject(LanguageService);

	public reserve(params: ReservationPageParameters): void {
		const language = this.languageService.selectedLanguage();
		let baseUrl = [getTranslatedRoutePath(AppRoutePath.Tours, language)];
		if (params.type === 'hotel') {
			baseUrl = [getTranslatedRoutePath(AppRoutePath.Hotels, language)];
		}

		this.router.navigate(
			[
				...baseUrl,
				formatUrlName(params.stateName),
				formatUrlName(params.regionName),
				formatUrlName(params.townName),
				formatUrlName(params.hotelName),
				getTranslatedRoutePath(AppRoutePath.Reservation, language),
			],
			{
				queryParams: {
					id: params.id,
					[SearchParametersConst.stateId]: params?.stateId,
					[SearchParametersConst.townFromId]: params?.townFromId,
					[SearchParametersConst.nights]: params?.night,
					[SearchParametersConst.hotelIds]: params.hotelId,
					[SearchParametersConst.checkInBegin]: params?.checkInBegin,
					[SearchParametersConst.adult]: params?.adult,
					[SearchParametersConst.child]: params?.child,
					[SearchParametersConst.childAges]: params?.childAges,
					[SearchParametersConst.townIds]: params.townId,
					[SearchParametersConst.currencyId]: params?.currencyId,
					[SearchParametersConst.serviceIds]: params.serviceId,
					[SearchParametersConst.roomTypeIds]: params.roomTypeId,
				},
				relativeTo: this.router.routerState.root.firstChild,
			}
		);
	}
}

export interface ReservationPageParameters {
	type: 'hotel' | 'tour';
	stateName: string;
	regionName: string;
	hotelName: string;
	townName: string;
	id: string;
	stateId?: number;
	townFromId?: number;
	night?: number[];
	hotelId?: number;
	checkInBegin?: string;
	adult?: number;
	child?: number;
	childAges?: number[];
	townId?: number;
	currencyId?: number;
	serviceId?: number;
	roomTypeId?: number;
}
